// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "(max-width: 768px)";
var _5 = "container-1yvcm";
var _6 = "info-6E0El";
var _7 = "passenger-pjCCC";
var _8 = "passenger__label-3L1cJ";
var _9 = "passenger__name-3Vuu_";
var _a = "passenger__type-1ohL2";
var _b = "seats__text-1OKPg";
var _c = "seats-15RFk";
var _d = "seats__label-1R1tB";
var _e = "seats__icon-fLjqW";
var _f = "controls-3t-H8";
var _10 = "disabled-2Zw6W";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "tabletMiddle", _5 as "container", _6 as "info", _7 as "passenger", _8 as "passenger__label", _9 as "passenger__name", _a as "passenger__type", _b as "seats__text", _c as "seats", _d as "seats__label", _e as "seats__icon", _f as "controls", _10 as "disabled" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "tabletMiddle": _4, "container": _5, "info": _6, "passenger": _7, "passenger__label": _8, "passenger__name": _9, "passenger__type": _a, "seats__text": _b, "seats": _c, "seats__label": _d, "seats__icon": _e, "controls": _f, "disabled": _10 }
